import { Cable } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CableIcon = createLucideIcon(Cable);
